import React from 'react'
import { useI18n } from '../../i18n'
import styles from '../../styles/components/assets/AssetsDataMap.module.scss'
import {
  type DataMapRow,
  SystemIdentityCell,
  SectionCell,
  MetricDisplay,
  CategoryPreview,
} from './dataMapRowParts'

interface Props {
  row: DataMapRow
  selected?: boolean
  onSelect: () => void
}

export default function DataMapSummaryRow({ row, selected, onSelect }: Props) {
  const { t } = useI18n()
  const unknown = t('common.unknown', '—')
  const count = row.dataCategories.length
  const withClassification = row.dataCategories.filter((c) => c.classification).length
  const previewNames = row.dataCategories
    .map((c) => c.classification)
    .filter(Boolean)
    .slice(0, 2)
    .join(', ')

  return (
    <article
      className={`${styles.summaryRow} ${selected ? styles.summaryRowSelected : ''}`.trim()}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onSelect()
        }
      }}
      role="button"
      tabIndex={0}
      aria-selected={selected}
    >
      <div className={styles.rowInner}>
        <div className={styles.rowGrid}>
          <SystemIdentityCell row={row} />
          <SectionCell label={t('assets.dataMap.categoryCount', 'Categories')}>
            <MetricDisplay value={count} unknownLabel={unknown} />
          </SectionCell>
          <SectionCell label={t('assets.dataMap.category', 'Data categories')}>
            <CategoryPreview
              categories={row.dataCategories}
              emptyLabel={t('assets.dataMap.noCategoriesForSystem', 'No categories.')}
            />
          </SectionCell>
          <SectionCell label={t('assets.dataMap.classification', 'Classification')}>
            <MetricDisplay
              value={withClassification > 0 ? withClassification : null}
              sub={previewNames || undefined}
              unknownLabel={t('assets.dataMap.noClassification', 'None')}
            />
          </SectionCell>
        </div>
      </div>
    </article>
  )
}
